


























import { authService } from '@/services/AuthService';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({})
export default class AppVerifyEmail extends Vue {
  @Action('logout')
  private logout!: () => void;

  @Prop()
  public authorizeAgain!: string;

  public retry() {
    if (this.authorizeAgain) {
      window.location.replace(this.authorizeAgain);
    } else {
      this.cancel();
    }
  }

  public cancel() {
    this.logout();
    authService.logout();
  }
}
